import React from 'react';		
//<88181>
const ListadoEquiSegVehiculoDinamico = props => (
  <div className="card card-plain card-lg">
	  <div className="wrapper tableFdv">
		    <div align="right">
		          <button  className="btn btn-blue-p" onClick={props.agregarParametrosESV} style={{ width: "95px", marginRight: "28px"}}>
					Agregar
				  </button>
		    </div>
			<br/>
			
			<div className="tableWrapper">	
			<table className="table table-hover"  style={{ marginBottom: "100px" }}>		
			  <tbody>
				{
				  props.arrevehiculos.length ?
					props.arrevehiculos.map((arreglo, index)  => (			   
					  <tr key={index}>
					    <td>
							<div className='wrapper'>	
				
									<div className='row'>							   
											<div className='col-md-10'>
													  <label className='labelInfo' htmlFor='Equipamiento'>Equipamiento</label>
													  <input className='form-control' id={`p_equipamiento`} name={`p_equipamiento`} type='text'												  
													   onChange={e => props.onUpdateItem(e, index)}                                                													  
													   defaultValue={arreglo.txtEquipamiento} />
											</div>
												
											<div className='col-md-1'>
													  <label className='labelInfo' htmlFor='NumeroOrden'>Orden</label>
													  <input className='form-control'
													  id={`p_nroorden`} 
													  name={`p_nroorden`}
													  type='number'
													  step="1"
                                                      min="1"
                                                      max="100"
                                                      required
                                                      onChange={e => props.onUpdateItem(e, index)}									
													  defaultValue={arreglo.numeroOrden} />
											</div>

											<div className='col-md-1'>
													  <label className='labelInfo' htmlFor='Inactivo'>Inactivo</label>
													  <input id={`p_inactivo`} name={`p_inactivo`} type='checkbox' 
													   onChange={e => props.onUpdateItem(e, index)}                                           												  
													   defaultChecked={arreglo.indInactivo === 'S' ? true : false} />
											</div>												 
									</div>								
									<div className='row'>							   
											<div className='col-md-12'>
													  <label className='labelInfo' htmlFor='Detalle'>Detalle</label>
													  <textarea id={`p_detalle`} name={`p_detalle`} 
													   rows="2" cols="250" className='form-control' 
                                                       onChange={e => props.onUpdateItem(e, index)} 													  
													   style={{'minHeight': '0px'}}								 
													   defaultValue={arreglo.txtDetalle} />
											</div>				
									</div>						   
									<div className='wrapper'>	
											<div className='row' align="right">
													<button className="btn btn-red-p"
    														onClick={(e) => { if (window.confirm('¿ Esta seguro que desea eliminar este registro?')) 
															props.eliminarParametrosESV(e,index,arreglo.codEquiSegVeg) } } style={{ width: "95px",marginRight: "15px", marginTop:"10px"}}>
                                                           Eliminar
                                                    </button>
													<button	  className="btn btn-orange-p"														                                                                    
																  onClick={( ) => props.grabarParametroESV(index, arreglo.codEquiSegVeg)} style={{ width: "95px", marginTop:"10px"}}>		
														   Guardar												  
													</button>	
											</div>										
									</div>	
						    </div>
						</td>				  
					  </tr>					 
					)) :						
							<tr>
							  <td colSpan={3}>No hay resultados</td>
							</tr>		
				}
			  </tbody>
			 </table>
			</div>
			 </div>
    </div>
);

export default ListadoEquiSegVehiculoDinamico;







// WEBPACK FOOTER //
// ./src/pages/MantSkuVehiculo/ListadoEquiSegVehiculoDinamico.js